import React from 'react'
import PropTypes from 'prop-types'

import Button from '@hixme-ui/button'
import Container from '@hixme-ui/container'
import Icon from '@hixme-ui/icon'
import Text from '@hixme-ui/text'

import DeclineMedicalButtonContainer from 'components/DeclineMedicalButton'
import { containers as userSessionContainers } from 'store/modules/user-session'
import GroupDropdownPicker from '../GroupDropdownPicker/GroupDropdownPicker'

const GroupNav = ({
  currentGroupIndex,
  onNextGroup,
  onBack,
  totalGroupCount,
  declineVisible,
  dropdownGroupVisible,
}) => (
  <Container
    flex
    noPadding
    justifyContent="space-between"
    alignCenter
    width="100%"
    margin="0 0 20px 0"
    style={{ fontFamily: 'SF Pro Text' }}
  >
    <Container flex noPadding alignCenter>
      <Icon light arrowLeft size={0.98} />
      <Text style={{ marginLeft: '4px' }} light fontSize="14px" cursor="pointer" onClick={onBack}>
        Back
      </Text>
    </Container>
    {dropdownGroupVisible && currentGroupIndex !== null && (
      <Container flex alignCenter width="100%" justifyCenter style={{ gap: '10px' }}>
        <Text medium style={{ fontFamily: 'Avenir Next', fontWeight: 500 }}>
          Select a Health Plan for
        </Text>
        <GroupDropdownPicker />
      </Container>
    )}
    {/* <Container flex noPadding width="100%" justifyContent="flex-start"> */}
    {/* {totalGroupCount > 1 && (
        <Button
          width="190px"
          disabled={currentGroupIndex === 0}
          onClick={onPreviousGroup}
        >
          Shop for previous group
        </Button>
      )} */}

    {/* <Container flex noPadding width="100%" justifyContent="flex-start">
        <Text large thin center>
          {`Choose a plan for ${personsName}`}
        </Text>
      </Container> */}
    {/* </Container> */}

    <Container
      flex
      noPadding
      width="100%"
      justifyContent="flex-end"
      alignItems="center"
      style={{ gap: '10px', flex: 1 }}
    >
      {declineVisible && <DeclineMedicalButtonContainer />}
      {currentGroupIndex + 1 !== totalGroupCount && (
        <Button width="190px" onClick={onNextGroup}>
          Continue
        </Button>
      )}
      {currentGroupIndex + 1 === totalGroupCount && (
        <userSessionContainers.SaveAndContinueButtonContainer />
      )}
    </Container>
  </Container>
)

GroupNav.propTypes = {
  currentGroupIndex: PropTypes.number,
  onNextGroup: PropTypes.func,
  totalGroupCount: PropTypes.number,
  declineVisible: PropTypes.bool,
  dropdownGroupVisible: PropTypes.bool,
  // personsName: PropTypes.string,
  onBack: PropTypes.func.isRequired,
}

GroupNav.defaultProps = {
  currentGroupIndex: 0,
  onNextGroup: () => {},
  onPreviousGroup: () => {},
  totalGroupCount: 0,
  declineVisible: false,
  dropdownGroupVisible: false,
  personsInCurrentGroup: [],
  personsName: '...',
}

GroupNav.displayName = 'GroupNav'

export default GroupNav
